import { render, staticRenderFns } from "./SearchBarToggle.vue?vue&type=template&id=527f2733"
import script from "./SearchBarToggle.vue?vue&type=script&lang=js"
export * from "./SearchBarToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports